import { canUseFedExGroundCollect } from './helpers';
import OptionsConstants from '../../constants/other-shipping-options-constants';
import { COLLECT } from '../../enums/bill-to-party';

export const shipmentOptions = 'shipment-options';
export const labelOptions = 'label-options';
export const deliveryOptions = 'delivery-options';
export const notificationOptions = 'notification-options';
export const marketplaceOptions = 'marketplace-options';
export const externalFulfillmentOptions = 'external-fulfillment-options';
export const windsorFrameworkOptions = 'windsor-framework-options';
export const serviceLevelOptions = 'service-level-options';
export const allCategories = [
  shipmentOptions,
  windsorFrameworkOptions,
  labelOptions,
  deliveryOptions,
  notificationOptions,
  marketplaceOptions,
  externalFulfillmentOptions,
  serviceLevelOptions,
];

// These map to OSO constants
export const additionalHandling = 'additionalHandling';
export const alcohol = 'containsAlcohol';
export const b13ACanada = 'b13ACanada';
export const collectOnDelivery = 'collectOnDelivery';
export const collectOnDeliverySimple = 'collectOnDeliverySimple'; // this is probably dead
export const consequentialLoss = 'consequentialLoss';
export const dangerousGoods = 'dangerousGoods';
export const dangerousGoodsLegacy = 'dangerousGoodsLegacy';
export const dangerousGoodsSimple = 'dangerousGoodsSimple';
export const dangerousGoodsDhlEcommerce = 'dangerousGoodsDhlEcommerce';
export const dangerousGoodsPurolator = 'dangerousGoodsPurolator';
export const deliveredDutyPaid = 'deliveredDutyPaid';
export const dontNotifyMarketplace = 'dontNotifyMarketplace';
export const dontPrepayPostage = 'dontPrepayPostage';
export const dryIce = 'dryIce';
export const emailNotification = 'emailNotification';
export const freightClass = 'freightClassCode';
export const holdForPickup = 'holdForPickup';
export const includeReturnLabel = 'includeReturnLabel';
export const localCollect = 'localCollect';
export const nonMachinable = 'nonMachinable';
export const safeplace = 'safeplace';
export const saturdayDelivery = 'saturdayDelivery';
export const saturdayGuarantee = 'saturdayGuarantee';
export const shipperRelease = 'shipperRelease';
export const smsNotification = 'smsNotification';
export const specialHandling = 'specialHandling';
export const thirdPartyConsignee = 'thirdPartyConsignee';
export const ancillaryEndorsement = 'ancillaryEndorsement';
export const blockAmazonLogistics = 'blockAmazonLogistics';
export const useBlankBox = 'useBlankBox';
export const goGreenPlus = 'goGreenPlus';
export const regulatedContentType = 'regulatedContentType';
export const notAtRisk = 'windsorFrameworkNotAtRisk';
export const movementIndicator = 'windsorFrameworkMovementIndicator';
export const fedExShipperLoadAndCount = 'fedExShipperLoadAndCount';
export const fedExBookingConfirmation = 'fedExBookingConfirmation';
export const exportLicenceRequired = 'exportLicenceRequired';
export const fragile = 'fragile';
export const deliveryAsAddressed = 'deliveryAsAddressed';
export const returnAfterFirstAttempt = 'returnAfterFirstAttempt';
export const serviceLevel = 'serviceLevel';

// These are who tf knows why we used these
export const confirmation = 'confirmation';
export const confirmationEnumId = 'confirmationEnumId';
export const printPostage = 'printPostage';
export const printPostageCode = 'print-postage';
export const billToAccountCode = 'bill-to-account';
export const billToAccount = 'billToAccount';

// this maps refData (SVGS Repo right now) to API format, and what's _generally_ used in-app
export const otherOptionMap = Object.freeze({
  [OptionsConstants.additionalHandling]: additionalHandling,
  [OptionsConstants.alcohol]: alcohol,
  [OptionsConstants.b13ACanada]: b13ACanada,
  [OptionsConstants.billToSender]: deliveredDutyPaid,
  [OptionsConstants.billToThirdParty]: billToAccount,
  [OptionsConstants.collectOnDelivery]: collectOnDelivery,
  [OptionsConstants.collectOnDeliverySimple]: collectOnDeliverySimple,
  [OptionsConstants.consequentialLoss]: consequentialLoss,
  [OptionsConstants.dangerousGoods]: dangerousGoods,
  [OptionsConstants.dangerousGoodsLegacy]: dangerousGoodsLegacy,
  [OptionsConstants.dangerousGoodsSimple]: dangerousGoodsSimple,
  [OptionsConstants.dangerousGoodsDhlEcommerce]: dangerousGoodsDhlEcommerce,
  [OptionsConstants.dangerousGoodsPurolator]: dangerousGoodsPurolator,
  [OptionsConstants.doNotNotifyMarketplace]: dontNotifyMarketplace,
  [OptionsConstants.dontPrepayPostage]: dontPrepayPostage,
  [OptionsConstants.dryIce]: dryIce,
  [OptionsConstants.emailNotification]: emailNotification,
  [OptionsConstants.freightClass]: freightClass,
  [OptionsConstants.holdForPickup]: holdForPickup,
  [OptionsConstants.includeReturnLabel]: includeReturnLabel,
  [OptionsConstants.localCollect]: localCollect,
  [OptionsConstants.nonMachinable]: nonMachinable,
  [printPostageCode]: printPostage,
  [OptionsConstants.safeplace]: safeplace,
  [OptionsConstants.saturdayDelivery]: saturdayDelivery,
  [OptionsConstants.saturdayGuarantee]: saturdayGuarantee,
  [OptionsConstants.shipperRelease]: shipperRelease,
  [OptionsConstants.smsNotification]: smsNotification,
  [OptionsConstants.specialHandling]: specialHandling,
  [OptionsConstants.thirdPartyConsignee]: thirdPartyConsignee,
  [OptionsConstants.ancillaryEndorsement]: ancillaryEndorsement,
  [OptionsConstants.useBlankBox]: useBlankBox,
  [OptionsConstants.blockAmazonLogistics]: blockAmazonLogistics,
  [OptionsConstants.goGreenPlus]: goGreenPlus,
  [OptionsConstants.regulatedContentType]: regulatedContentType,
  [OptionsConstants.notAtRisk]: notAtRisk,
  [OptionsConstants.movementIndicator]: movementIndicator,
  [OptionsConstants.fedExShipperLoadAndCount]: fedExShipperLoadAndCount,
  [OptionsConstants.fedExBookingConfirmation]: fedExBookingConfirmation,
  [OptionsConstants.exportLicenceRequired]: exportLicenceRequired,
  [OptionsConstants.fragile]: fragile,
  [OptionsConstants.deliveryAsAddressed]: deliveryAsAddressed,
  [OptionsConstants.returnAfterFirstAttempt]: returnAfterFirstAttempt,
  [OptionsConstants.serviceLevel]: serviceLevel,
});

export const ALL_DEFAULT_OPTIONS = [printPostageCode, OptionsConstants.nonMachinable, OptionsConstants.doNotNotifyMarketplace];
export const SHIPPING_DEFAULT_OPTIONS = [OptionsConstants.nonMachinable];

export const initialOptionState = (fulfillmentProperties) => ({
  [dryIce]: {
    weight: {
      unit: 'Ounces',
      value: '0',
    },
  },
  [collectOnDelivery]: {
    payment: {
      value: 0,
      code: 'USD',
    },
    paymentType: 'Any',
  },
  [dangerousGoods]: {
    contactName: '',
    contactPhone: '',
  },
  [dangerousGoodsLegacy]: {
    emergencyContact: '',
    goodsType: '',
  },
  [dangerousGoodsPurolator]: {
    class: '',
    mode: '',
  },
  [consequentialLoss]: {
    value: '',
  },
  [emailNotification]: {
    email: fulfillmentProperties?.email || '',
  },
  [smsNotification]: {
    phone: fulfillmentProperties?.phone || '',
  },
  [safeplace]: {
    instructions: '',
  },
  [billToAccount]: {
    billToParty: '',
    accountNumber: '',
    billingCountry: 'US',
    billingPostalCode: '',
  },
  [regulatedContentType]: '',
  [movementIndicator]: null,
  [serviceLevel]: '',
  [includeReturnLabel]: {
    labelProviderId: '',
    serviceId: '',
    packageTypeId: '',
  },
  [freightClass]: '',
  [b13ACanada]: '',
});
export const initialOptionStateKeys = Object.keys(initialOptionState());

export const cleanOptionsBasedOnSelectedServiceId = (serviceId, options) => {
  if (!options) {
    return {};
  }
  const cleanedOptions = {
    ...options,
  };
  if (!canUseFedExGroundCollect(serviceId) && options.billToAccount && options.billToAccount.billToParty === COLLECT) {
    delete cleanedOptions.billToAccount;
  }
  return cleanedOptions;
};

export const reassignDGToOptionsOnSelectedService = (supportedShippingOptions, options) => {
  const dgOptions = {
    [dangerousGoods]: null,
    [dangerousGoodsPurolator]: null,
    [dangerousGoodsDhlEcommerce]: null,
    [dangerousGoodsLegacy]: null,
    [dangerousGoodsSimple]: null,
  };

  const getIfSupported = (shippingOptionId, value, defaultValue = null) => {
    const isSupported = supportedShippingOptions.includes(shippingOptionId);
    return isSupported ? value : defaultValue;
  };

  dgOptions[dangerousGoods] = getIfSupported(OptionsConstants.dangerousGoods, options[dangerousGoods]);
  dgOptions[dangerousGoodsPurolator] = getIfSupported(OptionsConstants.dangerousGoodsPurolator, options[dangerousGoodsPurolator]);
  dgOptions[dangerousGoodsDhlEcommerce] = getIfSupported(OptionsConstants.dangerousGoodsDhlEcommerce, options[dangerousGoodsDhlEcommerce]);
  dgOptions[dangerousGoodsLegacy] = getIfSupported(OptionsConstants.dangerousGoodsLegacy, options[dangerousGoodsLegacy]);
  dgOptions[dangerousGoodsSimple] = getIfSupported(OptionsConstants.dangerousGoodsSimple, options[dangerousGoodsSimple]);

  return {
    ...options,
    ...dgOptions,
  };
};

export const createLabelSections = [
  shipmentOptions,
  serviceLevelOptions,
  windsorFrameworkOptions,
  labelOptions,
  deliveryOptions,
  notificationOptions,
];

export const standardSections = [...createLabelSections, marketplaceOptions];

export const externalFulfillmentSections = [marketplaceOptions, externalFulfillmentOptions];

export const optionsToValidate = [billToAccount, collectOnDelivery, dryIce, freightClass, includeReturnLabel];
